import React from 'react';

// Muestra solo la zona elegida en el editor (porcentajes de la foto original)
const FotoEncuadrada = ({ src, encuadre, alt }) => {
  if (!encuadre?.width) {
    return <img src={src} alt={alt} className="h-full w-full object-cover" style={{ objectPosition: '50% 35%' }} data-testid="landing-foto-img" />;
  }
  const escala = 100 / encuadre.width;
  return (
    <img src={src} alt={alt} className="absolute left-0 top-0 max-w-none origin-top-left" data-testid="landing-foto-img"
      style={{ width: 'calc(100% + 0.5px)', height: 'auto', transform: `translate3d(${-encuadre.x * escala}%, ${-encuadre.y * escala}%, 0) scale3d(${escala}, ${escala}, 1)` }} />
  );
};

const AnillosOro = () => (
  <svg className="pointer-events-none absolute inset-0 h-full w-full overflow-visible" viewBox="0 0 100 125" preserveAspectRatio="none" aria-hidden>
    <defs>
      <linearGradient id="boda-oro" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#E3CC94" />
        <stop offset="35%" stopColor="#B48A47" />
        <stop offset="65%" stopColor="#E8D6A6" />
        <stop offset="100%" stopColor="#A57A3A" />
      </linearGradient>
    </defs>
    <ellipse cx="50" cy="62.5" rx="49.6" ry="62.1" fill="none" stroke="url(#boda-oro)" strokeWidth="2.4" vectorEffect="non-scaling-stroke" />
    <ellipse cx="50" cy="62.5" rx="47.5" ry="59.4" fill="none" stroke="#C9A96A" strokeOpacity="0.85" strokeWidth="1" vectorEffect="non-scaling-stroke" />
  </svg>
);

export default function MarcoBoho({ src, encuadre, alt, style }) {
  return (
    <figure className="boda-anim boda-foto-marco relative mx-auto aspect-[4/5]" style={style} data-testid="landing-foto-pareja">
      <div className="absolute inset-[2.5%] overflow-hidden rounded-[50%]" style={{ background: '#EFE8D8' }}>
        <FotoEncuadrada src={src} encuadre={encuadre} alt={alt} />
      </div>
      <AnillosOro />
      <img src="/img/bodas/flores-superior.webp" alt="" aria-hidden className="boda-flores boda-flores-sup" />
      <img src="/img/bodas/flores-inferior.webp" alt="" aria-hidden className="boda-flores boda-flores-inf" />
    </figure>
  );
}
